export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  KNOWLEDGE_BASE: 'knowledge_base',
  MESSAGE_REPLY_TO: 'message_reply_to',
  SLA: 'sla',
  QUEUE_MANAGEMENT: 'queue_management',
  STUDIO: 'studio',
  DOCAL: 'docal',
  CSAT_SURVEY: 'csat_survey',
  NEW_REPORTING_ENABLED: 'new_reporting_enabled',
  CONCURRENT_USERS: 'concurrent_users',
};
